export type LocaleCode = 'ge' | 'en';

export const DEFAULT_LOCALE: LocaleCode = 'ge';
export const SUPPORTED_LOCALES: readonly LocaleCode[] = ['ge', 'en'];

export function isLocaleCode(value: unknown): value is LocaleCode {
  return typeof value === 'string' && (SUPPORTED_LOCALES as readonly string[]).includes(value);
}
